import { api } from './client'

export interface AssistantCard { id: string; kind: 'howto' | 'legal'; title: string; answer: string; route: string | null; source: string }
export interface AssistantAnswer {
  message_id: string; tier: 'kb' | 'llm'; answer: string
  related: AssistantCard[]; actions: { label: string; to: string }[]
  sources: { id: string; title: string; source: string }[]
  legal: boolean; disclaimer: string | null; notice: string | null
}
export interface AssistantStatus { enabled: boolean; llm_available: boolean; llm_configured: boolean; disclaimer: string }
export interface AssistantSuggestions { context: AssistantCard[]; chips: { id: string; label: string; route: string | null }[] }
export interface AssistantSettings {
  enabled: boolean; llm_enabled: boolean; allow_personal_data: boolean; retention_days: number
  llm_configured: boolean; model: string
  stats_30d: { questions: number; helpful: number; not_helpful: number; ai_answers: number }
}
export interface AssistantLogRow { id: string; question: string; answer: string; tier: string; rating: number | null; feedback: string | null; page: string | null; created_at: string }

export const getAssistantStatus = async (): Promise<AssistantStatus> => (await api.get('/api/v1/assistant/status')).data
export const getAssistantSuggestions = async (path: string): Promise<AssistantSuggestions> =>
  (await api.get('/api/v1/assistant/suggestions', { params: { path } })).data
export const askAssistant = async (question: string, page: string): Promise<AssistantAnswer> =>
  (await api.post('/api/v1/assistant/ask', { question, page })).data
export const rateAssistant = async (id: string, rating: 1 | -1): Promise<void> => {
  await api.post(`/api/v1/assistant/messages/${id}/feedback`, { rating })
}
export const getAssistantSettings = async (): Promise<AssistantSettings> => (await api.get('/api/v1/assistant/settings')).data
export const updateAssistantSettings = async (p: Partial<AssistantSettings>): Promise<AssistantSettings> =>
  (await api.put('/api/v1/assistant/settings', p)).data
export const getAssistantLog = async (rating?: 'down'): Promise<AssistantLogRow[]> =>
  (await api.get('/api/v1/assistant/log', { params: rating ? { rating } : undefined })).data

/** Open the assistant panel from anywhere (command palette, help links). */
export const ASSISTANT_OPEN_EVENT = 'bigroi:assistant-open'
export function openAssistant(question?: string) {
  window.dispatchEvent(new CustomEvent(ASSISTANT_OPEN_EVENT, { detail: { question } }))
}
